import React, { useState, useEffect } from 'react';
import {
  Lightbulb, BookOpen, Target, Heart, Briefcase, Wallet, Sparkles
} from 'lucide-react';

const categoryIcons = {
  '个人成长': Lightbulb,
  '健康': Heart,
  '职业': Briefcase,
  '财务': Wallet
};

function Footer({ templates, quotes, onUseTemplate }) {
  const [currentQuote, setCurrentQuote] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentQuote(prev => (prev + 1) % quotes.length);
    }, 10000);
    return () => clearInterval(interval);
  }, [quotes.length]);

  const quote = quotes[currentQuote];

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-grid">
          <div className="footer-section">
            <h3>
              <BookOpen size={18} />
              目标模板
            </h3>
            <div className="template-list">
              {templates.map((template, index) => {
                const Icon = categoryIcons[template.category] || Target;
                return (
                  <div
                    key={index}
                    className="template-item"
                    onClick={() => onUseTemplate(template)}
                  >
                    <Icon size={16} />
                    <span>{template.title}</span>
                  </div>
                );
              })}
            </div>
          </div>

          <div className="footer-section">
            <h3>
              <Sparkles size={18} />
              激励箴言
            </h3>
            <div className="motivation-quote">
              <p>"{quote.text}"</p>
              <span className="author">— {quote.author}</span>
            </div>
            <div style={{ display: 'flex', gap: '0.5rem', justifyContent: 'center' }}>
              {quotes.map((_, index) => (
                <div
                  key={index}
                  style={{
                    width: '8px',
                    height: '8px',
                    borderRadius: '50%',
                    background: index === currentQuote ? 'var(--gold)' : 'rgba(255,255,255,0.2)',
                    cursor: 'pointer',
                    transition: 'background 0.3s ease'
                  }}
                  onClick={() => setCurrentQuote(index)}
                />
              ))}
            </div>
          </div>

          <div className="footer-section">
            <h3>
              <Target size={18} />
              成功秘诀
            </h3>
            <ul style={{ listStyle: 'none', fontSize: '0.85rem', lineHeight: '2' }}>
              <li>✨ 将大目标分解为小步骤</li>
              <li>📅 设定明确的截止日期</li>
              <li>🎯 每周回顾并调整计划</li>
              <li>🏆 庆祝每一个小成就</li>
              <li>💪 保持一致性比完美更重要</li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>MilestoneMap © 2025 — 成就你的每一个里程碑</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
